<template>
	<footer class="w-100 py-4">
		<div class="footer container pt-3">
			<div class="row">
				<div class="col-6">
					<b class="text-uppercase pr-2">{{ $t('checkin.footerText.help') }}</b> {{ $t('checkin.footerText.helptext') }}
				</div>
				<div class="col-6 text-right">
					<b class="text-uppercase pr-2">{{ $t('checkin.footerText.reception') }}</b> {{ $t('checkin.footerText.receptiontext') }}
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		props: [],
		data: function () {
			return {
			}
		},
		methods: {
		},
		components: {}
	}
</script>

<style scoped lang="scss">

</style>
